import { apiFetch } from './utils/api';

export const clients = {
  get: async () => {
    const url = '/v1/users/me/clients';
    const { body } = await apiFetch(url, { method: 'GET' });
    return body;
  },
};
